export default __webpack_public_path__ + "static/media/team3.50f4eab1.jpg";